import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "row mb-1" };
const _hoisted_2 = { class: "col-6" };
const _hoisted_3 = { class: "col-6" };
const _hoisted_4 = { class: "flex-fill text-end fw-bold" };
const _hoisted_5 = {
    key: 0,
    class: "text-danger fw-bold"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.caption), 1),
        _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.fields, (tField) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: tField.member,
                    class: "d-flex flex-row"
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        (tField.validation?.state === 'pending')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Bitte prüfen Sie Ihre Eingabe..."))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.getValueCaption(_ctx.data[tField.member])), 1)
                            ], 64))
                    ])
                ]));
            }), 128))
        ])
    ]));
}
